import React, {useState} from 'react'
import DropdownMenuItem from './DropdownMenuItem'
import { ReactComponent as CogIcon } from '../icons/cog.svg';
import { ReactComponent as ChevronIcon } from '../icons/chevron.svg';
import { ReactComponent as MessengerIcon } from '../icons/messenger.svg';
import { ReactComponent as ArrowIcon } from '../icons/arrow.svg';
import { CSSTransition } from 'react-transition-group';
import { VscAccount } from "react-icons/vsc";
import { FaPhoneAlt } from "react-icons/fa";
import { ImExit } from "react-icons/im";
import {BsFillPeopleFill} from "react-icons/bs"
import {RiBuildingFill} from 'react-icons/ri'
import {FaFax} from 'react-icons/fa'
import {MdEmail} from 'react-icons/md'
import {FaArrowAltCircleLeft} from 'react-icons/fa'
import {IoDocumentTextSharp} from "react-icons/io5" 
import {GrLanguage} from "react-icons/gr"
import {HiOutlineTranslate} from "react-icons/hi";
import {ImBubbles4} from "react-icons/im";

const DropdownMenu = (props) => {

    const [activateMenu, setActiveMenu] = useState('main');
    const [menuHeight, setMenuHeight] = useState(null);

    const calcHeight = (el) =>{
        const height = el.offsetHeight+30; // added a little buffer
        setMenuHeight(height);
    }

    return (
        <div className="nav-dropdown" style={{ height: menuHeight }}>
            <CSSTransition 
            in={activateMenu === 'main'} 
            unmountOnExit 
            timeout={500}
            classNames="nav-menu-primary"  
            onEnter={calcHeight}
            >
                <div className="nav-menu">
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<IoDocumentTextSharp/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu="intakes"
                    link="#"
                    >
                        Intakes
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<FaPhoneAlt/>} 
                    rightIcon={<ChevronIcon/>}
                    goToMenu="contact us"
                    buttonBgColor="white"
                    link="#"
                    >
                        Contact Us
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<ImExit/>} 
                    rightIcon={<ChevronIcon/>}
                    goToMenu=""
                    buttonBgColor="white"
                    link="#"
                    onClick={props.handleLogout}
                    >
                        Logout
                    </DropdownMenuItem>
                </div>

            </CSSTransition>

            <CSSTransition 
            in={activateMenu === 'intakes'} 
            unmountOnExit 
            timeout={500}
            classNames="nav-menu-secondary"
            onEnter={calcHeight}
            >
                <div className="nav-menu">
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<FaArrowAltCircleLeft/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu="main"
                    link="#"
                    >

                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<ImBubbles4/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    changeTabState={props.changeTabState}
                    changeTabIndex={0}
                    link="#"
                    >
                        Translation
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<HiOutlineTranslate/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    changeTabState={props.changeTabState}
                    changeTabIndex={1}
                    link="#"
                    >
                        Interpretation
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<GrLanguage/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    changeTabState={props.changeTabState}
                    changeTabIndex={2}
                    link="#"
                    >
                        Bilingual Assessment
                    </DropdownMenuItem>
                </div>

            </CSSTransition>

            <CSSTransition 
            in={activateMenu === 'contact us'} 
            unmountOnExit 
            timeout={500}
            classNames="nav-menu-secondary"
            onEnter={calcHeight}        
            >
                <div className="nav-menu">
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<FaArrowAltCircleLeft/>} 
                    rightIcon={<ChevronIcon/>}
                    goToMenu="main"
                    buttonBgColor="white"
                    link="#"
                    >

                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<FaPhoneAlt/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    link="#"
                    >
                        Phone: (516)-396-2256
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<FaFax/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    link="#"
                    >
                        Fax: (516)-832-2255
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                    setActiveMenu={setActiveMenu}
                    leftIcon={<MdEmail/>} 
                    rightIcon={<ChevronIcon/>}
                    buttonBgColor="white"
                    goToMenu=""
                    link="mailto:lpasintakes@nasboces.org?subject=Intakes"
                    >
                        lpasintakes@nasboces.org
                    </DropdownMenuItem>
                </div>

            </CSSTransition>
        </div>
    )
}

export default DropdownMenu
